// export const baseUrl = 'http://localhost:8000/api';
export const baseUrl = 'https://api.imanage.services/api/api';
